import React from "react";
import { Platform } from "react-native";
import { defineMessages } from "react-intl";
import { Container } from "../layout/common";
import Button from "../button/Button";
import SearchField from "../field/SearchField";

const messages = defineMessages({
  search: {
    id: "search",
    defaultMessage: "Search"
  }
});

/**
 * Toolbar component for lists, this includes a search field and a refresh button (shown when running in a browser).
 * 
 * Props:
 * - refresh: Function that refreshes the contents of the list. This function will be called when the refresh button is pressed.
 * - filter: Function that must filter the contents of the list. This function will be called with the text entered in the search field as the first and only argument.
 * - currentFilter: Value of the current filter applied, used to display the filter value in the search field.
 * - placeholder: Any placeholder text that is wanted in the search field. By default this is "Search".
 * - style: Style applied to the container, which can be used to apply margins or padding.
 * - enableFilter: 
 * - showFilterPage: 
 */
const ListToolbar = ({ refresh, filter, currentFilter, placeholder, style, enableFilter, showFilterPage }) => (
  <Container margins="0 0 15px 0" flexDirection="row" alignItems="center" style={style}>
    <SearchField onChangeText={text => filter(text)} value={currentFilter} placeholder={placeholder || messages.search} flex={1} />

    {Platform.OS === "web" && <Button ui="link" leftIcon="sync-alt" margins="0 0 0 15px" onPress={() => refresh()} />}

    {/* FILTER */}
    {enableFilter && (
      <Button ui="link" leftIcon="filter" leftIconWeight="solid" margins="0 0 0 15px" onPress={() => showFilterPage && showFilterPage()} />
    )}
  </Container>
);

export default ListToolbar;
